import { useModuleBEM } from "@b2bportal/core-themes";
import { IconNameEnum } from "@b2bportal/core-themes";
import {
  CarouselScrollerContent,
  CarouselScrollerButton,
  CarouselScrollerRoot,
} from "@tenant/ui";
import { Icon } from "@tenant/ui";
import styles from "./Carousel.module.scss";

export const Carousel = ({ items }: { items: React.ReactNode[] }) => {
  const [, cn] = useModuleBEM(styles, "Carousel");
  return (
    <CarouselScrollerRoot>
      <CarouselScrollerButton direction="left">
        <Icon iconName={IconNameEnum.carouselLeftArrow} />
      </CarouselScrollerButton>
      <CarouselScrollerButton direction="right">
        <Icon iconName={IconNameEnum.carouselRightArrow} />
      </CarouselScrollerButton>
      <CarouselScrollerContent>
        {items.map((item, index) => (
          <div key={index} className={cn("item")}>
            {item}
          </div>
        ))}
      </CarouselScrollerContent>
    </CarouselScrollerRoot>
  );
};
